import React, { useEffect, useState } from 'react';
import UpdateScheduleForm from './UpdateScheduleForm';
import { getDealerSchedule, updateDealerSchedule } from '../../services/dealer';
import DotsLoading from '../ui/DotsLoading';

const defaultValues = {
  workingHours: {
    monday: {
      isWorking: true,
      start: '08:30',
      end: '18:00',
      breakStart: '12:00',
      breakEnd: '13:00'
    },
    tuesday: {
      isWorking: true,
      start: '08:30',
      end: '18:00',
      breakStart: '12:00',
      breakEnd: '13:00'
    },
    wednesday: {
      isWorking: true,
      start: '08:30',
      end: '18:00',
      breakStart: '12:00',
      breakEnd: '13:00'
    },
    thursday: {
      isWorking: true,
      start: '08:30',
      end: '18:00',
      breakStart: '12:00',
      breakEnd: '13:00'
    },
    friday: {
      isWorking: true,
      start: '08:30',
      end: '17:00',
      breakStart: '12:00',
      breakEnd: '13:00'
    },
    saturday: {
      isWorking: false,
      start: '09:00',
      end: '16:00',
      breakStart: '12:00',
      breakEnd: '13:00'
    },
    sunday: {
      isWorking: false,
      start: '09:00',
      end: '17:00',
      breakStart: '12:00',
      breakEnd: '13:00'
    }
  },
  slotDuration: 60,
  bufferTime: 10,
  maxAppointmentsPerSlot: 5,
  holidays: [],
  specialHours: []
};

const UpdateScheduleFormContainer = () => {
  const [values, setValues] = useState(defaultValues);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    getDealerSchedule()
      .then(data => data?.data)
      .then(data => {
        console.log('Schedule data:', data);
        if (data && data.schedule) {
          const schedule = data.schedule;
          const initialValues = {
            workingHours: schedule.workingHours || defaultValues.workingHours,
            slotDuration: schedule.slotDuration || 60,
            bufferTime: schedule.bufferTime || 10,
            maxAppointmentsPerSlot: schedule.maxAppointmentsPerSlot || 5,
            holidays: schedule.holidays || [],
            specialHours: schedule.specialHours || []
          };
          setValues(initialValues);
        }
      })
      .catch((err) => {
        console.error('Error loading schedule:', err);
        setError('Failed to load schedule');
      })
      .finally(() => setIsLoading(false));
  }, []);

  const handleSubmit = async (values, onSuccess) => {
    setIsSubmitting(true);
    setError('');
    setSuccess('');
    
    try {
      // Format dates for API
      const formattedValues = {
        ...values,
        holidays: values.holidays.map(holiday => ({
          ...holiday,
          date: holiday.date ? new Date(holiday.date).toISOString() : ''
        })),
        specialHours: values.specialHours.map(special => ({
          ...special,
          date: special.date ? new Date(special.date).toISOString() : ''
        }))
      };

      const res = await updateDealerSchedule(formattedValues);
      if (res && res.status === 'success') {
        setSuccess('Schedule updated successfully!');
        onSuccess();
      } else {
        setError(res.message || 'Failed to update schedule');
      }
    } catch (err) {
      console.error('Error updating schedule:', err);
      setError('Failed to update schedule');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isLoading) {
    return <DotsLoading />;
  }

  return (
    <UpdateScheduleForm
      values={values}
      onSubmit={handleSubmit}
      isSubmitting={isSubmitting}
      error={error}
      success={success}
    />
  );
};

export default UpdateScheduleFormContainer; 